module.exports = __webpack_public_path__ + "img/title-bg.96932896.png";